const data = (collection, keyword, systemStatus, billingStatus, paymentVerification) => (
  collection
    && Object.values(collection).filter((item) => {
      let available = false;
      if (
        (
          item.attributes.full_name
            .toLowerCase()
            .includes(keyword.toLowerCase())
        || item.attributes.email.toLowerCase().includes(keyword.toLowerCase())
        )
        && (
          systemStatus === null || systemStatus === '' || item.attributes.status === systemStatus
        )
        && (
          billingStatus === null || billingStatus === '' || item.attributes.status_billing === billingStatus
        )
        && (
          paymentVerification === null
            || paymentVerification === ''
            || item.attributes.status_verification === paymentVerification
        )
      ) available = true;

      return available;
    })
);

export default data;
